module.exports = __webpack_public_path__ + "img/CS26Q-中_05.09dbdd3a.jpg";